const AuthProviders = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft'
};

export default AuthProviders;
